import gql from 'graphql-tag'

export const fasiData = gql`
  query fasiData($locale: SiteLocale, $slug: String) {
    fasi(locale: $locale, filter : {slug: {eq: $slug}}) {
        titolo
        slug
        seo {
          description
          title
          twitterCard
          image {
            url
          }
        }
        position
        intro
        titleContent
        iconTabs {
          svg {
            url
          }
          text
        }
        doubleColumn
        contentText
        coverDesk {
          responsiveImage {
            src
            srcSet
          }
        }
        coverMobile {
          responsiveImage {
            srcSet
            src
          }
        }
        svgCover {
          responsiveImage {
            alt
            base64
            bgColor
            title
            src
            srcSet
          }
          url
        }
        videoId
        videoLink
        image {
          responsiveImage {
            srcSet
            src
          }
          url
        }
        imageMobile {
          responsiveImage {
            srcSet
            src
          }
          url
        }
        backgroundImageBlock {
          titolo
          backgroundImageDesk {
            responsiveImage {
              srcSet
              src
            }
          }
          backgroundImageMobile {
            responsiveImage {
              src
              srcSet
            }
          }
          list {
            elementoLista
          }
        }
        _allSlugLocales {
          locale
          value
        }
    }
        allFasis(locale: $locale) {
            position
            titolo
            slug
          }
        
}
`

export const allFasis = gql`
  query allFasis($locale: SiteLocale) {
    allFasis(locale: $locale) {
            position
            titolo
            slug
            abstract
            coverDesk {
                responsiveImage {
                  src
                  srcSet
                }
              }
            coverMobile {
                responsiveImage {
                  src
                  srcSet
                }
              }  
          }
}
`

export const allFasiLocale = gql`
  query allFasis {
    allFasis {
      _allSlugLocales {
        locale
        value
      } 
     }
}
`

export const faseLocale = gql`
query fasi($locale: SiteLocale, $slug: String) {
  fasi(locale: $locale, filter : {slug: {eq: $slug}}) {
      _allSlugLocales {
        locale
        value
      } 
     }
}
`
